var exports = {
  "kL": "xcc377c0b--58ad27--container",
  "nV": "xcc377c0b--58ad27--gallery",
  "_8": "xcc377c0b--58ad27--img",
  "hJ": "xcc377c0b--58ad27--counter",
  "h_": "xcc377c0b--58ad27--description",
  "DD": "xcc377c0b--58ad27--title",
};

module.exports = exports;
